import React from 'react';
import styles from './style.module.scss';
import PricingCard from './components/shared/PricingCard';
import RateItem from './components/shared/RateItem';
import { RegularCardIcons, AmexCardIcon } from './constants/icons';

const FlatRate = ({ values, formatCurrency, formatPercentage }) => {
  return (
    <div className={styles.flatRate}>
      <div className={styles.rateCards}>
        {/* Regular Cards Rate */}
        <PricingCard 
          title="Rate Fees"
          icons={<RegularCardIcons />}
        >
          <div className={styles.ratesList}>
            <RateItem 
              label="Flat Rate"
              value={formatPercentage(values.flat_rate)}
            />
            <RateItem 
              label="Txn Rate"
              value={formatCurrency(values.flat_rate_transaction)}
            />
          </div>
        </PricingCard>

        {/* AMEX Rate */}
        <PricingCard 
          title="Rate Fees AMEX"
          icons={<AmexCardIcon />}
        >
          <div className={styles.ratesList}>
            <RateItem 
              label="Flat Rate"
              value={formatPercentage(values.flat_rate_amex)}
            />
            <RateItem 
              label="Txn Rate"
              value={formatCurrency(values.flat_rate_amex_transaction)}
            />
          </div>
        </PricingCard>
      </div>
    </div>
  );
};

export default FlatRate; 